import MarketRequestsWorkspace from 'broker/pages/SubmissionWorkspacePage/components/TabsPanel/common/MarketRequestsWorkspace';
import HeaderButtons from './HeaderButtons';

export default function Marketing() {
  return <MarketRequestsWorkspace headerButtons={<HeaderButtons />} />;
}
